import { TranslateService } from '@ngx-translate/core';

export class DynamicLocaleId extends String {
    
    constructor(protected translate: TranslateService) {
        super('');
    }
    
    toString() {
        return this.translate.currentLang ? this.translate.currentLang : 'en';
    }
}